import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ResumeDirectionsSubTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function ResumeDirectionsSubTab() {
  const [directions, setDirections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editingDirection, setEditingDirection] = useState(null);
  const [formData, setFormData] = useState({ name: '', description: '' });

  useEffect(() => {
    fetchDirections();
  }, []);

  const fetchDirections = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/resume-directions`);
      setDirections(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке направлений: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingDirection) {
        await axios.put(`${API_URL}/api/resume-directions/${editingDirection.id}`, {
          name: formData.name,
          description: formData.description || null
        });
      } else {
        await axios.post(`${API_URL}/api/resume-directions`, {
          name: formData.name,
          description: formData.description || null
        });
      }
      setShowForm(false);
      setEditingDirection(null);
      setFormData({ name: '', description: '' });
      fetchDirections();
      setError(null);
    } catch (err) {
      setError('Ошибка при сохранении: ' + (err.response?.data?.detail || err.message));
    }
  };

  const handleEdit = (d) => {
    setEditingDirection(d);
    setFormData({ name: d.name, description: d.description || '' });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Удалить это направление резюме?')) {
      try {
        await axios.delete(`${API_URL}/api/resume-directions/${id}`);
        fetchDirections();
      } catch (err) {
        setError('Ошибка при удалении: ' + (err.response?.data?.detail || err.message));
      }
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingDirection(null);
    setFormData({ name: '', description: '' });
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="resume-directions-sub-tab">
      <div className="tab-header">
        <h2>Направления резюме</h2>
        {!showForm && (
          <button className="btn btn-primary" onClick={() => setShowForm(true)}>
            + Добавить направление
          </button>
        )}
      </div>

      {error && <div className="error-message">{error}</div>}

      {showForm && (
        <div className="form-container">
          <h3>{editingDirection ? 'Редактировать направление' : 'Новое направление'}</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="resume_dir_name">Название *</label>
              <input
                type="text"
                id="resume_dir_name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                maxLength={255}
                placeholder="Например: Frontend"
              />
            </div>
            <div className="form-group">
              <label htmlFor="resume_dir_description">Описание</label>
              <textarea
                id="resume_dir_description"
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                rows={3}
                placeholder="Краткое описание направления"
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                {editingDirection ? 'Сохранить' : 'Создать'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Отмена
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Название</th>
              <th>Описание</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {directions.length === 0 ? (
              <tr>
                <td colSpan="4" className="empty-state">
                  Нет направлений. Добавьте первое.
                </td>
              </tr>
            ) : (
              directions.map((d) => (
                <tr key={d.id}>
                  <td>{d.id}</td>
                  <td>{d.name}</td>
                  <td>{d.description || '—'}</td>
                  <td>
                    <button
                      className="btn-icon btn-edit"
                      onClick={() => handleEdit(d)}
                      title="Редактировать"
                    >
                      ✏️
                    </button>
                    <button
                      className="btn-icon btn-delete"
                      onClick={() => handleDelete(d.id)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ResumeDirectionsSubTab;
